module.exports = __webpack_public_path__ + "692b50fdd84f6367edae6014c97206a1.svg";